// extracted by mini-css-extract-plugin
export default {"offer":"Offers-offer_G6H1x"};